module.exports = __webpack_public_path__ + "files/b7e8b829485d35cd9d450da4578f71f7.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activities-1.png
// module id = 517
// module chunks = 76